// extracted by mini-css-extract-plugin
export default {"wrapper":"Aop0t","icon":"LCnNR"};